import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ContainsValue from './ContainsValue';

const CheckboxFormValue = ({
  selectedOperator,
  fieldName,
  showLabel,
  availableValueOptions,
  readOnly = false
}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
      return (
        <EqualValue
          showLabel={showLabel}
          fieldName={fieldName}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );

    case Operator.CONTAINS:
      return (
        <ContainsValue
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS ATTRIBUTE IS UNDEFINED*/}</>;

    default:
      return <></>;
  }
};

export default CheckboxFormValue;
